var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('EditProductModal',_vm._g(_vm._b({ref:"editModal"},'EditProductModal',{ product: _vm.product, categories: _vm.categories, tags: _vm.tags, updating: _vm.updating },false),{ submit: _vm.handleProductUpdate }))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }